import React from 'react';
import './EmptyState.css';
import { FaInbox } from 'react-icons/fa';

const EmptyState = ({
    icon: Icon = FaInbox,
    title = "No Data Available",
    message = "There's currently no information to display here. Try adjusting your filters or checking back later.",
    actionText,
    onAction,
    compact = false
}) => {
    return (
        <div className={`empty-state-container ${compact ? 'compact' : ''}`}>
            <div className="empty-state-icon">
                <Icon />
            </div>
            <h3 className="empty-state-title">{title}</h3>
            <p className="empty-state-message">{message}</p>
            {actionText && onAction && (
                <button className="empty-state-action" onClick={onAction}>
                    {actionText}
                </button>
            )}
        </div>
    );
};

export default EmptyState;
